import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=9d9d0990&scoped=true&"
import script from "./feedBack.vue?vue&type=script&lang=js&"
export * from "./feedBack.vue?vue&type=script&lang=js&"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=9d9d0990&prod&lang=less&scoped=true&"
import style1 from "./feedBack.vue?vue&type=style&index=1&id=9d9d0990&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9d0990",
  null
  
)

export default component.exports